module.exports = __webpack_public_path__ + "assets/img/51d4d4460af07b20fc2a1ea9da8c39cb.png";